// extracted by mini-css-extract-plugin
module.exports =  {"labelWrapper":"kCA7FAsBpjPfPkERSYfU","preview":"Ny4sWAg4RXGWqY0zrVMb","logoUrl":"qwoXVv5i6fUoJfaAtFOx","faviconUrl":"hqrqMb9HqM6CuShwDsKT","imagePicker":"XiNVgqT2sUlR6kM592VZ"};